var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Divider, Grid, Typography, styled, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CreateAppointment, validateAppointmentURL } from '../../../api/url';
import { SuccessIconNew } from '../../../assets/images';
import { MuiPopup, MuiStack } from '../../../components';
import UnsavedChangesPopup from '../../../components/molecules/unsavedChangesPopup';
import { EParentModuleName, ESystemName } from '../../../constants';
import { useAppDispatch } from '../../../store/hooks';
import { dateFormate, getTime } from '../../../utils/utils';
import SearchByTypeIndex from '../../commonViews/searchByType/searchByType.index';
var MyImg = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "48px",
        marginRight: "5px",
        width: "48px"
    };
});
var CreateAppointmentIndex = function () {
    var _appointmentDetailsRe, _appointmentDetailsRe2;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var _a = useState(false), openPopup = _a[0], setOpenPopup = _a[1];
    var _b = useState(null), appointmentDetailsResponse = _b[0], setAppointmentDetailsResponse = _b[1];
    var _c = useState(false), openUnsavedPopup = _c[0], setOpenUnsavedPopup = _c[1];
    var isDocDataUpdated = useSelector(function (state) { return state.common; }).isDocDataUpdated;
    var handleHeaderBackClick = function () {
        if (isDocDataUpdated) {
            setOpenUnsavedPopup(true);
        }
        else {
            navigate("/appointment");
        }
    };
    var onClickYesBtn = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setOpenUnsavedPopup(false);
            return [2 /*return*/];
        });
    }); };
    var onClickNoBtn = function () {
        navigate('/appointment');
    };
    var onAppoinmentCreatedSuccessfully = function (documentCreateResponse) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // const response: any = await dispatch(getByIdAPI({ key: '', url: getAppontmentDetailsByIdUrl(documentCreateResponse.AppointmentId) }))
            // if (response.payload.success && response.payload.data) {
            //     setAppointmentDetailsResponse(response.payload.data)
            // }
            setAppointmentDetailsResponse(documentCreateResponse);
            setOpenPopup(true);
            return [2 /*return*/];
        });
    }); };
    var onClickCreateNewAppt = function () {
        window.location.reload();
    };
    var onClickGoToHomePage = function () {
        navigate('/appointment');
    };
    var handleCloseClick = function () {
        // dispatch(setState({ key: "createAndEditFlow", value: { isAppointment: "Update" } }))
        navigate("/appointment-Detail/".concat(appointmentDetailsResponse === null || appointmentDetailsResponse === void 0 ? void 0 : appointmentDetailsResponse.AppointmentId));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SearchByTypeIndex, {
        headerTitle: "Schedule appointment",
        SystemName: ESystemName.Appointment,
        isCheckBoxVisible: true,
        validateDocumentURL: validateAppointmentURL,
        parentComponent: EParentModuleName.Appointment,
        createDocumentURL: CreateAppointment,
        headerBackClick: function () { return handleHeaderBackClick(); },
        onSuccessfullDocumentCreate: onAppoinmentCreatedSuccessfully,
        createAndEditFlow: {
            isAppointment: "Create"
        }
    }), /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: openPopup,
        onClose: function () { return onClickGoToHomePage(); },
        closeIcon: true,
        subTitleVariant: "h4",
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: true,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            // width: "calc(90vw)",
            width: lgMode ? '500px' : 'calc(90vw)',
            paddingTop: 0,
            paddingX: "16px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        sm: 12,
        md: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MyImg, {
        id: "SuccessIcon",
        src: SuccessIconNew,
        alt: "settingIcon"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        marginTop: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "xl",
        fontWeight: "strong"
    }, "".concat(t("Scheduled successfully!"))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: {
            xs: "column",
            sm: "row"
        },
        spacing: 0.5,
        marginTop: 1,
        alignItems: {
            xs: "start",
            sm: "center"
        },
        flexWrap: "wrap"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: 'AppointmentNo',
        fontSize: "base",
        fontWeight: "normal",
        color: "secondary.600",
        whiteSpace: "nowrap"
    }, t('Appointment'), " :"), /*#__PURE__*/ React.createElement(Typography, {
        id: "appointment-id",
        fontSize: "base",
        fontWeight: "medium",
        sx: {
            wordBreak: 'break-word'
        }
    }, (_appointmentDetailsRe = appointmentDetailsResponse === null || appointmentDetailsResponse === void 0 ? void 0 : appointmentDetailsResponse.Code) !== null && _appointmentDetailsRe !== void 0 ? _appointmentDetailsRe : '-')), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        bgcolor: "#F5F7FA",
        padding: 2,
        marginTop: 2,
        borderRadius: 3
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "base",
        fontWeight: "medium"
    }, (_appointmentDetailsRe2 = appointmentDetailsResponse === null || appointmentDetailsResponse === void 0 ? void 0 : appointmentDetailsResponse.RepairTypeName) !== null && _appointmentDetailsRe2 !== void 0 ? _appointmentDetailsRe2 : '-'), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            marginY: 2
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "base",
        fontWeight: "normal"
    }, "".concat(t("Scheduled Date"))), /*#__PURE__*/ React.createElement(Typography, {
        id: 'Scheduled-Date',
        fontSize: "base",
        fontWeight: "normal"
    }, appointmentDetailsResponse !== null && appointmentDetailsResponse !== void 0 && appointmentDetailsResponse.SlotStartTime ? dateFormate(appointmentDetailsResponse === null || appointmentDetailsResponse === void 0 ? void 0 : appointmentDetailsResponse.SlotStartTime) : "-")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between",
        spacing: 1,
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "base",
        fontWeight: "normal"
    }, t("Scheduled Time")), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "base",
        fontWeight: "normal",
        id: 'Scheduled-Time',
        variant: "h3"
    }, appointmentDetailsResponse !== null && appointmentDetailsResponse !== void 0 && appointmentDetailsResponse.SlotStartTime ? getTime(appointmentDetailsResponse === null || appointmentDetailsResponse === void 0 ? void 0 : appointmentDetailsResponse.SlotStartTime) : "-"))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: {
            xs: "column",
            sm: 'row-reverse'
        },
        spacing: 1.5,
        marginTop: 4
    }, /*#__PURE__*/ React.createElement(Button, {
        id: "CreateNewApp",
        variant: "contained",
        color: "primary",
        fullWidth: true,
        size: "large"
        // style={{
        //     // borderColor: "#DEE4EB",
        //     width: "100%",
        // }}
        ,
        children: t("Create new appointment"),
        onClick: onClickCreateNewAppt
    }), /*#__PURE__*/ React.createElement(Button, {
        id: "RedirectHomePage",
        variant: "outlined",
        color: "secondary",
        fullWidth: true,
        size: "large"
        // style={{
        //     // borderColor: "secondary.200",
        //     width: "100%",
        //     // fontWeight:'medium'
        // }}
        ,
        children: t("Go to homepage"),
        onClick: onClickGoToHomePage
    })))), /*#__PURE__*/ React.createElement(UnsavedChangesPopup, {
        isOpen: openUnsavedPopup,
        onClosePopup: function (value) { return setOpenUnsavedPopup(value); },
        onClickNoBtn: onClickNoBtn,
        onClickYesBtn: onClickYesBtn
    }));
};
export default CreateAppointmentIndex;
